import { observer } from 'mobx-react-lite'
import { NewInboxContent } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/NewInboxContent'
import { useNewInboxStepsContext } from 'pages/settings/pages/inboxes/pages/newInbox/context/newInboxStepsContext'
import styles from './styles.module.scss'

export const GeneralInfo = observer(() => {
  const { generalInfoStore, nextClickHandler } = useNewInboxStepsContext()
  const { nextDisabled } = generalInfoStore

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <NewInboxContent
          newInboxStore={generalInfoStore}
          nextButtonName='Next'
          nextClick={nextClickHandler}
          disabledButton={nextDisabled}
        />
      </div>
    </div>
  )
})
